"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MobileIcon = require("./MobileIcon");

var _MobileIcon2 = _interopRequireDefault(_MobileIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _MobileIcon2.default;